import { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import closeSvg from 'assets/icons/close.svg';
import Modal from 'lib/Modal';
import Button, { Color, Size } from 'lib/Button';
import { Store } from 'components/common/types/Store.types';

interface TerminateDialogProps {
  isTerminateModalVisible: boolean;
  setShowTerminateModal: (isVisible: boolean) => void;
  handleTerminateLine: () => void;
}

const TerminateDialog = ({
  isTerminateModalVisible,
  setShowTerminateModal,
  handleTerminateLine,
}: TerminateDialogProps): ReactElement => {
  const name = useSelector((state: Store) => state.dealManagement.commonDeal.currentLine.name);

  return (
    <Modal
      dataTestId="terminate-line-modal"
      isOpen={isTerminateModalVisible}
      icon={closeSvg}
      title={`Terminate ${name}?`}
      actionButtons={
        <>
          <Button color={Color.PRIMARY} onClick={() => setShowTerminateModal(false)} size={Size.LARGE} label="Cancel" />
          <Button color={Color.DANGER} onClick={handleTerminateLine} size={Size.LARGE} label="OK" />
        </>
      }
    >
      <div className="ml-8 body-base text-neutral-950-opacity-60">
        <p className="mb-2">
          Terminating a live line will stop all trading immediately, and you will be unable to undo this.
        </p>
        <p>
          Are you sure you want to terminate <strong>{name}</strong>?
        </p>
      </div>
    </Modal>
  );
};

export default TerminateDialog;
